import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { faCaretDown, faFileExport, faTrash } from '@fortawesome/pro-solid-svg-icons';

import DeletionConfirmation from './deletion_confirmation';
import FileSystem from 'components/file_system';
import { excludedColumns, fileSystemAdditionalColumns, fileSystemAttributeOverrides } from './config';

export default function Attachment({
  attachment,
  deletable,
  index,
  onDelete,
  onMoveUp,
  onPreview,
  onRename,
  ...props
}) {
  const [deleting, setDeleting] = useState();

  const fileSystemAttachment = useMemo(() => ({
    ...attachment,
    icon: attachment.ottercon,
    lastModified: attachment.createdAt,
    name: attachment.displayName,
    url: attachment.downloadUrl,
  }), [attachment]);

  const handlePreview = onPreview || (() => window.open(attachment.downloadUrl, '_blank'));
  const actions = useMemo(() => {
    const actions = [];

    if (attachment.folderId) {
      actions.push({
        key: 'moveUp',
        icon: faFileExport,
        label: 'Move to parent folder',
        callback: () => onMoveUp(attachment),
      });
    }

    if (deletable) {
      actions.push({
        key: 'delete',
        icon: faTrash,
        label: 'Delete',
        callback: () => setDeleting(true),
      });
    }

    return actions;
  }, [attachment]);

  return <React.Fragment>
    <FileSystem.Row
      actionIcon={faCaretDown}
      actions={actions}
      additionalColumns={fileSystemAdditionalColumns}
      attributeOverrides={fileSystemAttributeOverrides}
      excludedColumns={excludedColumns}
      file={fileSystemAttachment}
      index={index}
      onPreview={handlePreview}
      onRename={onRename}
      {...props}
    />

    <DeletionConfirmation
      attachment={attachment}
      show={deleting}
      onClose={() => setDeleting(false)}
      onDelete={onDelete}
    />
  </React.Fragment>;
}

Attachment.propTypes = {
  attachment: PropTypes.shape({
    downloadUrl: PropTypes.string,
    displayName: PropTypes.string,
    folderId: PropTypes.number,
    ottercon: PropTypes.string,
  }).isRequired,
  deletable: PropTypes.bool,
  index: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onPreview: PropTypes.func,
  onRename: PropTypes.func,
};
